<template>
  <div class="cal-sidebar-dates-container" :class="styleClass">
    <div class="cal-sidebar-date">
      <small>{{ sidebarLabels['from-label'] }}</small>
      <div class="cal-sidebar-date__wrapper">
        <input type="hidden" value="">
        <div class="cal-sidebar-date__day">{{ dateFrom.day }}</div>
        <div class="cal-sidebar-date__text">
          <div class="cal-sidebar-date__month-year">{{ dateFrom.monthYear }}</div>
          <div class="cal-sidebar-date__weekday">{{ dateFrom.weekday }}</div>
        </div>
      </div>
    </div>
    <div class="cal-sidebar-date">
      <small>{{ sidebarLabels['to-label'] }}</small>
      <div class="cal-sidebar-date__wrapper">
        <div class="cal-sidebar-date__day">{{ dateTo.day }}</div>
        <div class="cal-sidebar-date__text">
          <div class="cal-sidebar-date__month-year">{{ dateTo.monthYear }}</div>
          <div class="cal-sidebar-date__weekday">{{ dateTo.weekday }}</div>
        </div>
      </div>
    </div>
    <div class="cal-sidebar-price ms-auto d-md-none">
      <div>{{ translate('general.Price') }}</div>
      <strong class="text-nowrap">{{ initialShownPrice }} € </strong>
    </div>
  </div>


</template>

<script>
import {translate} from "@elements/translations";

export default {
  props: {
    dateFrom: Object,
    dateTo: Object,
    labels: String,
    sidebarLabels: Object,
    initialShownPrice: String,
    styleClass: String
  },
  mounted() {},
  methods: {
    translate
  }
}

</script>